import styled from '@emotion/styled/macro'

const TooltipText = styled('span')`
  font-size: 0.875rem;
  white-space: pre-line;
`

export { TooltipText }
